import { RootState } from '@store/store.ts'

export const getMetroSelector = (state: RootState): number => {
  return state.metro.selectedMetro?.id ?? 1
}
